import NoteIcon from '@mui/icons-material/Note';
import React from 'react';
import { toUnderScoreSlug } from '../../lib/helpers/helpers';

const integrationDocs_menuItems = [
  {
    icon: <NoteIcon />,
    tooltip: 'Dashboard',
    text: 'Dashboard',
    name: 'Dashboard',
    slug: '/dashboard',
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Getting Started',
    text: 'Getting Started',
    name: 'Getting Started',
    slug: toUnderScoreSlug('Getting Started'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Retrieving Results',
    text: 'Retrieving Results',
    name: 'Retrieving Results',
    slug: toUnderScoreSlug('Retrieving Results'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Choose Integration',
    text: 'Choose Integration',
    name: 'Choose Integration',
    slug: toUnderScoreSlug('Choose Integration'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Customize Integration',
    text: 'Customize Integration',
    name: 'Customize Integration',
    slug: toUnderScoreSlug('Customize Integration'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'API Endpoints',
    text: 'API Endpoints',
    name: 'API Endpoints',
    slug: toUnderScoreSlug('API Endpoints'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Schemas',
    text: 'Schemas',
    name: 'Schemas',
    slug: toUnderScoreSlug('Schemas'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Data Dictionary',
    text: 'Data Dictionary',
    name: 'Data Dictionary',
    slug: toUnderScoreSlug('Data Dictionary'),
    href: 'https://www.dropbox.com/s/v2cts8ximhk3355/DataExport.DataDictionary.February%202022.xlsx?dl=0',
  },
  {
    icon: <NoteIcon />,
    tooltip: 'FAQs',
    text: 'FAQs',
    name: 'FAQs',
    slug: toUnderScoreSlug('FAQs'),
  },
  {
    icon: <NoteIcon />,
    tooltip: 'Submit Bug',
    text: 'Submit Bug',
    name: 'Submit Bug',
    slug: toUnderScoreSlug('Submit Bug'),
    href: 'https://forms.gle/8UdF6uYJCyTmwaK19',
  },
];

export default integrationDocs_menuItems;

/* 
    - Getting started
    - Retrieving Results
    - Choose Integration
    - API endpoints
    - Schemas
    - Data Dictionary
    - FAQs
    - Submit Bug
    - Log OUT
*/
